import script from "./TypeListContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./TypeListContainer.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__